import timeline      from './components/TimeLine.js';
import parallax      from './components/Paralax.js';
import organicEffect from './components/OriganicEffect.js';

function init() {
    timeline();
    parallax();
    organicEffect();
}

(function () {
    init();
}());
